import type { CouponId } from './CouponId.js';
import type { CouponIndex } from './CouponIndex.js';

export { quickPickEnum } from './boardProps.js';
export { formatBetTo1X2String } from './Coupon.js';
export {
  type Bet,
  type Coupon,
  indexToOutcomeString,
  type Outcome,
  outcomeStringToIndex,
  type SROW,
  toOutcome,
} from './Coupon.js';
export { type CouponId, type CouponType, getCouponId } from './CouponId.js';
export { type CouponIndex, getCouponIndex } from './CouponIndex.js';
export type CouponIdentifiers = {
  couponId: CouponId;
  couponIndex: CouponIndex;
};
export type CouponBoardIdentifiers = {
  boardIndex: number;
} & CouponIdentifiers;
export type { CouponStatus } from './CouponStatus.js';
